import api from '@/services/api'
import StatusProjectEnum from '@/enum/statusProjectEnum'
import TypeCollaboratorEnum from '@/enum/typeCollaboratorEnum'

export default {
  state: {
    projectSelected: {
      id: '',
      runtime: 0,
      status: '',
      type: '',
      typeCollaboratorProjectSelected: 0,
    },
  },

  mutations: {
    SET_PROJECT_SELECTED(state, payload) {
      state.projectSelected = {
        id: payload.id ? payload.id : '',
        runtime: payload.runtime ? Number(payload.runtime) : 0,
        status: payload.status ? payload.status : '',
        type: payload.type ? payload.type : '',
        typeCollaboratorProjectSelected: payload.typeCollaboratorProjectSelected
          ? Number(payload.typeCollaboratorProjectSelected)
          : null,
      }
    },
  },

  actions: {
    async saveProject({ commit }, project) {
      try {
        return await api.post('/projects', project)
      } catch (error) {
        throw error
      }
    },

    async getProjects({ commit }) {
      try {
        const response = await api.get('/projects')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getProject({ commit }, projectId) {
      try {
        const response = await api.get(`/projects/${projectId}`)

        const data = response && response.data ? response.data : null

        commit('SET_PROJECT_SELECTED', data)

        return data
      } catch (error) {
        throw error
      }
    },

    async updateProject({ commit }, project) {
      try {
        const response = await api.put(`/projects/${project.id}`, project)

        commit('SET_PROJECT_SELECTED', project)

        return response
      } catch (error) {
        throw error
      }
    },
  },

  getters: {
    projectSelected: (state) => state.projectSelected,
    canEditProject: (state) =>
      (state.projectSelected.status === StatusProjectEnum.EM_CADASTRO ||
        state.projectSelected.status ===
          StatusProjectEnum.REPROVADO_COM_AJUSTES) &&
      state.projectSelected.typeCollaboratorProjectSelected !== null,
    isCollaboratorPrincipalProject: (state) =>
      state.projectSelected.typeCollaboratorProjectSelected ===
      TypeCollaboratorEnum.PRINCIPAL,
  },
}
